import { NavLink, Outlet, useParams } from "react-router-dom";

const AttendeesTab = () => {
  const { churchId } = useParams();

  return (
    <>
      <nav>
        <NavLink to="/"></NavLink>
        <NavLink to=":churchId?"></NavLink>
      </nav>
      <main>
        <Outlet context={[churchId]} />
      </main>
    </>
  );
};

export default AttendeesTab;
